import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface CreateAppointmentPayload {
  customer_name: string;
  customer_contact: string;
  customer_email: string;
  gender: string;
  stylist_id: string[];  // Array of stylist IDs
  service_id: string[];  // Array of service IDs
  appointment_date: string;
  start_time: string;
  status: string;
  notes?: string;
  discount: number;
  price: number;
}

interface BookingState {
  isLoading: boolean;
  error: string | null;
  appointmentId: string | null;
  success: boolean;
}

const initialState: BookingState = {
  isLoading: false,
  error: null,
  appointmentId: null,
  success: false,
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    createAppointment: (state, _action: PayloadAction<CreateAppointmentPayload>) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createAppointmentSuccess: (state, action: PayloadAction<{ appointmentId: string }>) => {
      state.isLoading = false;
      state.appointmentId = action.payload.appointmentId;
      state.success = true;
      state.error = null;
    },
    createAppointmentFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetBooking: (state) => {
      state.isLoading = false;
      state.error = null;
      state.appointmentId = null;
      state.success = false;
    },
  },
});

export const {
  createAppointment,
  createAppointmentSuccess,
  createAppointmentFailure,
  resetBooking,
} = bookingSlice.actions;

export default bookingSlice.reducer;
